import React from 'react';
import SgfUtil from './modules/sgf/sgfUtil';
import Square from './square';
import { toWinRate } from './modules/utils';

function getMoveNumber(props, index) {
  if (props.moveNumbers.length <= index) {
    return 0;
  } else if (props.viewMode === "moveNumber") {
    const arr = props.moveNumbers[index].filter(
      number => number <= props.moveNumber
    )
    if (arr.length) {
      return arr[0];
    }
  } else if (props.viewMode === "variation"
    && props.variationMoves && props.variationMoves.length) {
    return props.moveNumbers[index][0];
  }
  return 0;
}

function isLastMove(props, index) {
  if (props.boardModel && props.boardModel.lastMove) {
    const v = props.boardModel.lastMove;
    const lastMoveIndex = SgfUtil.vertexToIndex(
      v, props.boardSize);
    return lastMoveIndex === index;
  }
  return false;
}

function getSquare(props, col, index) {
  return (
    <Square
      key={index}
      row={props.row}
      col={col}
      boardSize={props.boardSize}
      player={
        props.boardModel
          ? props.boardModel.getStateAtIndex(index) : 0
      }
      visit={
        props.prediction
          ? props.prediction.visits[index]
          : 0
      }
      winRate={
        props.prediction
          ? toWinRate(props.prediction.evaluations[index])
          : 0
      }
      variationLetter={props.variationLetters[index]}
      lastMove={isLastMove(props, index)}
      moveNumber={getMoveNumber(props, index)}
      rank={props.rank ? props.rank[index] : 0}
      viewMode={props.viewMode}
      width={props.width}
      height={props.height}
      fontSize={props.fontSize}
      onClick={props.onClick.bind(this, index)}
    />
  );
}

function BoardRow(props) {
  const cols = Array(props.boardSize).fill().map(
    (_, i) => {
      let index = props.row * props.boardSize + i;
      return getSquare(props, i, index);
    });

  return (
    <div className="board-row">
      {cols}
    </div>
  );
}

export default BoardRow;